import { showUpdateBanner } from './updateBanner'

export const CHECK_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes

export async function initBuildUpdateChecker() {
  let currentHash

  try {
    const response = await fetch('/build-meta.json', { cache: 'no-store' })
    if (!response.ok) return
    const data = await response.json()
    currentHash = data.contentHash
  } catch {
    // build-meta.json not available yet — silently exit
    return
  }

  if (!currentHash) return

  const intervalId = setInterval(async () => {
    if (document.visibilityState !== 'visible') return

    try {
      const response = await fetch('/build-meta.json', { cache: 'no-store' })
      if (!response.ok) return
      const data = await response.json()

      if (data.contentHash !== currentHash) {
        clearInterval(intervalId)
        showUpdateBanner()
      }
    } catch {
      // Network error — ignore silently
    }
  }, CHECK_INTERVAL_MS)
}
